import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-614b37b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center mb-lg-4 mb-3" }
const _hoisted_2 = { class: "pb-3 fw-bold page-name" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "bg-white shadow mb-5 rounded-4 p-3 p-lg-4 community-site-post-card"
}
const _hoisted_8 = { class: "d-flex justify-content-between mb-4 -p-1 align-items-start" }
const _hoisted_9 = {
  key: 0,
  class: "pulsate block-time"
}
const _hoisted_10 = {
  key: 1,
  class: "user d-flex align-items-center"
}
const _hoisted_11 = { class: "fs-8 date-text" }
const _hoisted_12 = { class: "content border-bottom position-relative mb-4" }
const _hoisted_13 = { class: "content__main pb-4" }
const _hoisted_14 = { class: "mb-4 pb-4 border-bottom" }
const _hoisted_15 = {
  key: 0,
  class: "pulsate block-title"
}
const _hoisted_16 = {
  key: 1,
  class: "fw-bold ps-lg-0 text-break mb-0"
}
const _hoisted_17 = { class: "d-flex flex-column" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"pulsate block-line-content\" data-v-614b37b5></div><div class=\"pulsate block-line-content\" data-v-614b37b5></div><div class=\"pulsate block-line-content mb-1halfrem\" data-v-614b37b5></div><div class=\"pulsate block-image\" data-v-614b37b5></div><div class=\"pulsate block-line-content\" data-v-614b37b5></div><div class=\"pulsate block-line-content\" data-v-614b37b5></div><div class=\"pulsate block-line-content\" data-v-614b37b5></div>", 7)
const _hoisted_26 = [
  _hoisted_19
]
const _hoisted_27 = {
  key: 1,
  class: "position-relative community-site-post-content"
}
const _hoisted_28 = { class: "ql-snow" }
const _hoisted_29 = { class: "ql-editor only-view-editor no-padding" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "d-flex flex-wrap m-20" }
const _hoisted_32 = { class: "d-flex flex-wrap" }
const _hoisted_33 = { class: "d-flex flex-wrap m-20" }
const _hoisted_34 = {
  key: 0,
  class: "d-flex btn-container justify-content-sm-end ml-auto"
}
const _hoisted_35 = {
  key: 1,
  class: "d-flex justify-content-end ml-auto"
}
const _hoisted_36 = { class: "mt-1halfrem text-center" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "detail-artical-btn shadow secondary small fw-bold false"
}, "戻る", -1))
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "detail-artical-btn shadow secondary small fw-bold false"
}, "戻る", -1))

import { translate } from '@/languages/i18n'
import { computed, ComputedRef, ref, onMounted, watch } from 'vue'
import { COMMUNITY_SITE_STORE, POST_STORE, ACCOUNT_STORE, COMMUNITY_STORE } from '@/store/constants'
import { LIST_USER_NAME } from '@/constants/common'
import communityService from '@/services/community-site.service'
import { useStore } from 'vuex'

import HashTag from '@/components/hash-tag/index.vue'
import LikeButton from '@/components/like-button/index.vue'
import Comment from '@/views/shared/communities/components/Comment.vue'
import UserComments from '@/views/shared/communities/components/UserComments.vue'
import LikeModal from '@/views/shared/communities/components/LikeModal.vue'
import DeleteCommentModal from '@/views/shared/communities/components/DeleteCommentModal.vue'
import DeleteCommentSuccessModal from '@/views/shared/communities/components/DeleteCommentSuccessModal.vue'

import { useRoute, useRouter } from 'vue-router'
import { ChangeTime } from '@/constants/datepicker'
import { Modal } from 'bootstrap'
import { isSaasTypePool, purifyContent } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()

const post = computed<ComputedRef>(() => store.getters[COMMUNITY_SITE_STORE.GETTERS.COMMUNITY_SITE_POST_DETAIL].post)

const loadingPost = computed<ComputedRef>(() => store.getters[COMMUNITY_SITE_STORE.GETTERS.COMMUNITY_SITE_POST_DETAIL].loadingPosts)

const deleteTargetPostId = ref<string>()

const deleteTargetPostCommentId = ref<string>()

const deleteTargetCommentPublished = ref<boolean>()
const idComment = ref(null)

const modalDeleteCommentSuccess = ref()
const commentIsDelete = ref(true)

const users = computed(() => store.getters[POST_STORE.GETTERS.LIST_USER_MENTION_POST])
const mentionUsers = computed(() => LIST_USER_NAME(users.value?.data, users.value))
const listUserShow = computed<ComputedRef>(() => store.getters[ACCOUNT_STORE.GETTERS.LIST_USER_WITH_DELETED])

const storeSaasType = computed(() => store.getters[COMMUNITY_STORE.GETTERS.GET_SAAS_TYPE])

const setCommentData = (post_id, id, published) => {
  deleteTargetPostId.value = post_id
  deleteTargetPostCommentId.value = id
  deleteTargetCommentPublished.value = published
}

const showDeleteCommentSuccessModal = (isDelete) => {
  commentIsDelete.value = isDelete
  modalDeleteCommentSuccess.value.show()
}

const loadingLike = ref<boolean>(false)

const handleLike = async (post) => {
  loadingLike.value = true
  try {
    const likeRes = post.like ? await communityService.disLikePost(post.id) : await communityService.likePost(post.id)
    if (likeRes.data?.success) {
      const newPost = {
        like_count: post['like'] ? (post['like_count'] ?? 0) - 1 : (post['like_count'] ?? 0) + 1,
        like: !post['like'],
      }

      store.dispatch(COMMUNITY_SITE_STORE.ACTIONS.UPDATE_LIKE_CSP, newPost)
      setTimeout(() => {
        loadingLike.value = false
      }, 500)
    }
  } catch (error) {
    console.log(error)
    loadingLike.value = false
  }
}

onMounted(async () => {
  idComment.value = route.query?.target_content_id
  await store.dispatch(COMMUNITY_SITE_STORE.ACTIONS.GET_COMMUNITY_SITE_POST_DETAIL, {
    community_id: route?.params?.id,
    post_id: router.currentRoute.value.params?.post_id,
    params: {
      target_content_id: route.query?.target_content_id,
    },
  })
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_USER_WITH_DELETED, route?.params?.id)

  if (storeSaasType.value && !isSaasTypePool(storeSaasType.value)) {
    await store.dispatch(COMMUNITY_SITE_STORE.ACTIONS.GET_USER_MENTION_CSP, router.currentRoute.value.params?.post_id)
  }

  const elementDeleteCommentSuccessModal = document.getElementById('deleteCommentSuccess')
  modalDeleteCommentSuccess.value = new Modal(elementDeleteCommentSuccessModal)
})

watch(
  () => loadingPost.value,
  (value) => {
    if (!value) {
      setTimeout(() => {
        const linkableComponents = document.querySelectorAll('.community-site-post-content a')
        linkableComponents.forEach((linkableComponent) => {
          linkableComponent.setAttribute('target', '_blank')
        })
      }, 300)
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(translate)('communitySite')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(loadingPost))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    (!_unref(loadingPost))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_unref(loadingPost))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(post)?.published_date ? _unref(ChangeTime)(_unref(post)?.published_date) : '-'), 1)
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (_unref(loadingPost))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                  : (_openBlock(), _createElementBlock("h4", _hoisted_16, _toDisplayString(_unref(post)?.title), 1))
              ]),
              _createElementVNode("div", _hoisted_17, [
                (_unref(loadingPost))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_26))
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", {
                            innerHTML: _unref(purifyContent)(_unref(post)?.content)
                          }, null, 8, _hoisted_30)
                        ])
                      ])
                    ])),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(post)?.tags, (tag) => {
                      return (_openBlock(), _createBlock(HashTag, {
                        key: tag.id,
                        tag: tag,
                        searchable: true,
                        class: "me-2 mb-2"
                      }, null, 8, ["tag"]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  (!_ctx.isMobile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createVNode(LikeButton, {
                          class: "me-2 jus",
                          count: _unref(post)?.like_count,
                          like: _unref(post)?.like,
                          id: _unref(post)?.id,
                          type: 'like',
                          "data-bs-toggle": 'modal',
                          "data-bs-target": _unref(post)?.like_count === 0 ? '' : '#like',
                          handleLikeOrInterest: () => handleLike(_unref(post)),
                          my_post: _unref(post)?.user_post?.my_post,
                          available: _unref(post)?.user_post?.available,
                          is_deleted_in_30_days: _unref(post)?.user_post?.is_deleted_in_30_days,
                          loadingLike: loadingLike.value,
                          user_type: _unref(post)?.user_post?.user_type
                        }, null, 8, ["count", "like", "id", "data-bs-target", "handleLikeOrInterest", "my_post", "available", "is_deleted_in_30_days", "loadingLike", "user_type"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isMobile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createVNode(LikeButton, {
                          class: "me-2",
                          count: _unref(post)?.like_count,
                          like: _unref(post)?.like,
                          id: _unref(post)?.id,
                          type: 'like',
                          "data-bs-toggle": 'modal',
                          "data-bs-target": _unref(post)?.like_count === 0 ? '' : '#like',
                          handleLikeOrInterest: () => handleLike(_unref(post)),
                          available: _unref(post)?.user_post?.available,
                          my_post: _unref(post)?.user_post?.my_post,
                          is_deleted_in_30_days: _unref(post)?.user_post?.is_deleted_in_30_days,
                          loadingLike: loadingLike.value,
                          user_type: _unref(post)?.user_post?.user_type
                        }, null, 8, ["count", "like", "id", "data-bs-target", "handleLikeOrInterest", "available", "my_post", "is_deleted_in_30_days", "loadingLike", "user_type"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          (!_unref(isSaasTypePool)(_unref(storeSaasType)))
            ? (_openBlock(), _createBlock(UserComments, {
                key: 0,
                comments: _unref(post)?.comments,
                comment_count: _unref(post)?.comment_count,
                postId: _unref(post)?.id,
                isCSPDetail: true,
                mention_users: _unref(listUserShow),
                id_comment: idComment.value,
                class: "no-padding-left",
                onSetCommentData: setCommentData
              }, null, 8, ["comments", "comment_count", "postId", "mention_users", "id_comment"]))
            : _createCommentVNode("", true),
          (!_unref(isSaasTypePool)(_unref(storeSaasType)))
            ? (_openBlock(), _createBlock(Comment, {
                key: 1,
                class: "no-padding-left",
                post: _unref(post),
                admin: false,
                isCSPDetail: true,
                users: _unref(mentionUsers),
                titleMention: _unref(translate)('titleMentionPostDetail')
              }, null, 8, ["post", "users", "titleMention"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_36, [
            (_unref(route).path.includes('community_site_posts_details'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createVNode(_component_router_link, {
                    to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}/community_site`
                  }, {
                    default: _withCtx(() => [
                      _hoisted_38
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createVNode(_component_router_link, {
                    to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}/community_site_posts`
                  }, {
                    default: _withCtx(() => [
                      _hoisted_40
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(LikeModal, { class: "modal-community-site-detail" }),
    _createVNode(DeleteCommentModal, {
      onShowDeleteCommentSuccessModal: showDeleteCommentSuccessModal,
      postId: deleteTargetPostId.value,
      postCommentId: deleteTargetPostCommentId.value,
      commentPublishedFlg: deleteTargetCommentPublished.value,
      isCSPDetail: true
    }, null, 8, ["postId", "postCommentId", "commentPublishedFlg"]),
    _createVNode(DeleteCommentSuccessModal, { "is-delete": commentIsDelete.value }, null, 8, ["is-delete"])
  ], 64))
}
}

})